import { environment } from "src/environments/environment";

const  HOST = window.location.origin;

export const AppConfig = Object.freeze({
    HOST_URL: HOST,
    BASE_API_URL:  `${environment.URL}/api/v1`,
    BASE_CDP_URL:  `${environment.URL}/cdp/v1`,
    BASE_ADSP_URL: `${environment.URL}/adsp/v1`,
    BASE_BDSP_URL: `${environment.URL}/bdsp/v1`,
    BASE_TDSP_URL: `${environment.URL}/tdsp/v1`,
    BASE_DCO_URL: `${environment.URL}/dco/v1`,
    BASE_AI_BOT_URL: `${environment.URL}/shared/ai`,
    WHITE_LABEL_MODE: environment.white_label_mode,
    SUPPORTED_DSPS:  environment.supported_dsps,
    TITLE: `${environment.title}`,
    BRAND_PRIMARY_COLOUR: `${environment.brand_primary_color}`,
    BRAND_SECONDARY_COLOUR: `${environment.brand_secondary_color}`,
    BRAND_TERTIARY_COLOUR: `${environment.brand_tertiary_color}`,
    CHIP_COLOR: `${environment.chip_color}`,
    CHIP_BG_COLOR: `${environment.chip_bg_color}`,
    MSG_BG_COLOR: `${environment.message_bg_color}`,
    SITE_LOGO: `${environment.site_logo}`,
    POPUP_LOGO: `${environment.popup_logo}`,
    WELCOME_IMG: `${environment.welcome_img}`,
    LOGIN_IMG: `${environment.login_img}`,
    JS_TAG: `${environment.js_tag}`,
    IMG_TAG: `${environment.img_tag}`,
    BASE_SHARED_URL: `${environment.URL}/shared`,
    BASE_CDP_V2_URL: `${environment.CDP_URL}`,
    IS_CDP_ALLOWED: environment.allow_CDP
});
